import _ from "lodash";

export const encodeSearchParams = (advancedSearch, filters) => {
  const searchParams = {
    advancedSearch: advancedSearch,
    filters: filters
  };

  if (
    _.isEmpty(searchParams.advancedSearch) &&
    _.isEmpty(searchParams.filters)
  ) {
    return "";
  } else if (
    _.isEmpty(searchParams.advancedSearch) &&
    !_.isEmpty(searchParams.filters)
  ) {
    delete searchParams.advancedSearch;
  } else if (
    !_.isEmpty(searchParams.advancedSearch) &&
    _.isEmpty(searchParams.filters)
  ) {
    delete searchParams.filters;
  }

  return encodeURIComponent(JSON.stringify(searchParams));
};

export const decodeSearchParams = search => {
  const searchParams =
    search && JSON.parse(decodeURIComponent(search.substring(1)));

  return {
    advancedSearch: _.get(searchParams, "advancedSearch") || null,
    filters: _.get(searchParams, "filters") || null
  };
};

export const getFilterFromRouteState = (state, filter) => {
  return _.get(state, "routing.location.search")
    ? {
        filters: _.get(
          JSON.parse(
            decodeURIComponent(
              _.get(state, "routing.location.search").substring(1)
            )
          ),
          filter
        )
      }
    : null;
};

export const getFinalQueryString = string => {
  return string ? "?" + string.substring(1) : "";
};

export const getPageQueryString = pageIndex => {
  return `&page=${pageIndex + 1}`;
};



// WEBPACK FOOTER //
// ./src/utils/parseQueries.js